import React from "react";
import "./AboutUs2.css";
import img1 from "./img/8979.jpg";
import img2 from "./img/5618.jpg";
import img3 from "./img/little-girl-sitting-table-using-modern-tablet.jpg";

import WhyChooseUs from "./WhyChooseUs";
import CareerProspects from "./CareerProspects";
import CompanySlider from "./CompanySlider";
import PlacementSection from "./PlacementSection";

export default function AboutUs() {
  return (
    <div className="aboutus-wrapper">
      {/* About Us Section */}
      <section className="section about-section">
        <div className="gallery">
          <img src={img1} alt="Edu Tech" className="big-img" />
          <div className="small-gallery">
            <img src={img2} alt="Edu Tech" />
            <img src={img3} alt="Edu Tech" />
          </div>
        </div>
        <div className="content">
          <h2>About Us</h2>
          <p>
            At <b>Edu Tech Master Academy</b>, we believe in shaping futures
            through world-class learning experiences. Our platform offers
            technology, business, and creative courses designed to build
            practical skills.
          </p>
          <p>
            With expert mentors and a vibrant community, students get not only
            knowledge but also confidence to excel.
          </p>
        </div>
      </section>
      <WhyChooseUs />
      <CareerProspects />
      <CompanySlider />
      <PlacementSection />
    </div>
  );
}
